<template>
  <div class="compressed-content">
    <h3 class="page-question">On your last carotid angiogram, was ANY amount of blockage (plaque) noted on your arteries?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hasArteriesBlockage">
      <b-form-radio v-model="survey.arteryBlockages.lastAngiogramCarotidTest.hasArteriesBlockage" name="ratio" :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.arteryBlockages.lastAngiogramCarotidTest.hasArteriesBlockage" name="ratio" :value="false">No</b-form-radio>
    </v-form-group>
    <h3 class="mb-3 page-question">How old were you when you had this angiogram completed?</h3>
    <v-form-group class="page-buttons" :validator="$v.age" label="Age">
      <b-form-input slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="survey.arteryBlockages.lastAngiogramCarotidTest.doneAtAge"
                    placeholder="18 - 90" />
    </v-form-group>
    <h3 class="mt-5 page-question">Did your angiogram show MORE blockage than any previous carotid angiogram?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.isProgression">
      <b-form-radio v-model="survey.arteryBlockages.lastAngiogramCarotidTest.isProgression" name="progress" :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.arteryBlockages.lastAngiogramCarotidTest.isProgression" name="progress" :value="false">No</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, between, numeric } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      hasArteriesBlockage: {
        required
      },
      age: {
        required,
        between: between(18, 90),
        numeric
      },
      isProgression: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      hasArteriesBlockage() { return this.survey.arteryBlockages.lastAngiogramCarotidTest.hasArteriesBlockage; },
      age() { return this.survey.arteryBlockages.lastAngiogramCarotidTest.doneAtAge; },
      isProgression() { return this.survey.arteryBlockages.lastAngiogramCarotidTest.isProgression; }
    }
  };
</script>